const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "GMDSS_SATELLITE_TYPES_RETRIEVED":
            return action.availableGmdssSatelliteTypes;

        default:
            return state;
    }
}
